import { ModalCustom } from "components/ModalCustom";
import { DropdownSelect } from "components/DropdownSelect";
import { useEffect, useState } from "react";
import {
  ContainerCheckbox,
  ContainerDropdown,
  DadosPlanilha,
  DadosPlanilhaInfo,
  DadosPlanilhaTitulo,
} from "./style";
import { tipoVeiculoFipeOptions } from "features/processo/utils/tipoVeiculoIntegracaoFipe";

interface IProps {
  setDadosTabela: (dadosTabela: any) => void;
  dadosTabela: any;
  chassi: string;
  show: boolean;
  handleClose: () => void;
  setShow: (show: boolean) => void;
}

export function ModalEscolherTipoVeiculo({
  setDadosTabela,
  dadosTabela,
  chassi,
  show,
  handleClose,
  setShow,
}: IProps) {
  const [tipoSelecionado, setTipoSelecionado] = useState<string>("");
  const [tipoPlanilha, setTipoPlanilha] = useState<string>("");
  const [placaSelecionada, setPlacaSelecionada] = useState<string>("");
  const [aplicarTodos, setAplicarTodos] = useState<boolean>(false);

  const onConfirm = () => {
    const novosDados = dadosTabela.map((dado: any) => {
      if (
        dado.veiculo.chassi === chassi ||
        (aplicarTodos && !dado.veiculo.tipo)
      ) {
        return {
          ...dado,
          veiculo: {
            ...dado.veiculo,
            tipo: tipoSelecionado,
            marcaModelo: null,
            sugestoesMarcaModelo: null,
          },
        };
      }
      return dado;
    });
    setShow(false);
    setAplicarTodos(false);
    setDadosTabela(novosDados);
  };

  useEffect(() => {
    const dadosVeiculo = dadosTabela.filter(
      (dado: any) => dado.veiculo.chassi === chassi
    );

    if (dadosVeiculo.length) {
      setTipoSelecionado(dadosVeiculo[0].veiculo.tipo ?? "");
      setPlacaSelecionada(dadosVeiculo[0].veiculo.placa ?? "");
      setTipoPlanilha(dadosVeiculo[0].veiculo.tipoPlanilha ?? "");
      return;
    }

    setPlacaSelecionada("");
    setTipoSelecionado("");
    setTipoPlanilha("");
  }, [show]);

  return (
    <ModalCustom
      handleClose={handleClose}
      show={show}
      title="Escolher tipo de veículo"
      footer
      footerConfirmButton
      onConfirm={onConfirm}
      centered
    >
      <ContainerDropdown>
        <DadosPlanilha>
          <DadosPlanilhaTitulo>Dados da planilha</DadosPlanilhaTitulo>
          <DadosPlanilhaInfo>
            Tipo: {tipoPlanilha.length ? tipoPlanilha : "--"}
          </DadosPlanilhaInfo>
          <DadosPlanilhaInfo>
            Placa: {placaSelecionada.length ? placaSelecionada : "--"}
          </DadosPlanilhaInfo>
          <DadosPlanilhaInfo>Chassi: {chassi ?? "--"}</DadosPlanilhaInfo>
        </DadosPlanilha>
        <div style={{ marginBottom: 4 }}>Escolha o tipo na listagem abaixo</div>
        <DropdownSelect
          searchable
          onSelect={(value) => {
            setTipoSelecionado(value);
          }}
          options={tipoVeiculoFipeOptions}
          selectedValue={tipoSelecionado}
          required
        />
      </ContainerDropdown>
      <ContainerCheckbox>
        <input
          onChange={(e) => setAplicarTodos(e.target.checked)}
          type="checkbox"
          checked={aplicarTodos}
        />
        <label
          style={{
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "100%",
            letterSpacing: "0%",
            marginLeft: 8,
          }}
        >
          Aplicar este tipo para todos os veículos sem tipo
        </label>
      </ContainerCheckbox>
    </ModalCustom>
  );
}
